// Feed nudges — gentle, periodic tips pushed to the bottom message feed that
// steer the player toward the core loop: claim wild land → grow rice → get rich.
// Messages are CONTEXTUAL (based on how much rice/land the player has) so they
// stay relevant, and never repeat back-to-back.

import { getWealth } from '../game/seasonManager.js'
import { countByType } from '../game/plotState.js'
import { active } from '../game/state.js'
import { PlotTypes } from '../config/balance.js'
import { fieldCoords } from '../scene/hexGrid.js'
import { pushLog } from './hud.js'

const FIRST_DELAY_MS = 22_000 // let the player settle in before the first tip
const INTERVAL_MS = 80_000    // then a tip roughly every ~1.3 min

let lastMsg = ''

function pickNudge() {
  const k = active()
  const farms = countByType(PlotTypes.FARM)
  const season = k.season
  const ownedCount = Object.keys(k.plots ?? {}).length // only owned tiles are stored
  const wildLeft = fieldCoords().length - ownedCount
  const wealth = getWealth()

  const out = []
  // Contextual nudges (most relevant first).
  if (farms <= 2) {
    out.push('🌾 Rice is your fortune — claim wild land and zone it as a Rice Paddy. Every paddy makes each harvest click pay more.')
  }
  if (season === 'HARVEST') {
    out.push('🌾 Harvest season! The more rice paddies you own, the bigger every click. Claim more land and plant rice.')
  }
  if (wealth > 20_000 && farms < 8) {
    out.push('💰 You have coin to spend — claim more land and grow rice to multiply your harvest income.')
  }
  if (wildLeft > 20) {
    out.push('🎋 The bamboo wilderness waits. Claim a wild tile to expand your kingdom and grow more rice.')
  }
  // Generic fallbacks (always available).
  out.push('🌾 Tip: rice paddies are your main source of Mao Coin — the more you grow and harvest, the richer you become.')
  out.push('🎋 Expand outward: claim wild tiles, zone them as rice, and watch your harvest grow.')

  let pick = out[Math.floor(Math.random() * out.length)]
  for (let i = 0; i < 5 && pick === lastMsg; i++) {
    pick = out[Math.floor(Math.random() * out.length)]
  }
  lastMsg = pick
  return pick
}

export function mountFeedNudges() {
  setTimeout(() => pushLog(pickNudge()), FIRST_DELAY_MS)
  setInterval(() => pushLog(pickNudge()), INTERVAL_MS)
}
